import {
  Banknote,
  CalendarClock,
  CloudLightning,
  FilePlus2,
  FileWarning,
  FileX2,
  type LucideIcon,
  MessageCircleOff,
  MessageSquareX,
  Plane,
  ReceiptText,
  Scale,
  Speech,
  XCircle,
} from "lucide-react";

export type AdversaryRefusalReasonType =
  | "ASSIGNMENT_REFUSAL"
  | "NO_RESPONSE"
  | "CX"
  | "ADDITIONAL_FEES_REFUSAL"
  | "ASK_FOR_ADDITIONAL_DOCS"
  | "RESPONSABILITY_SHIFT_TO_OTHER_AIRLINE"
  | "ASK_FOR_EXCESSIVE_DOCUMENTATION"
  | "NOT_ELIGIBLE_REFUSAL"
  | "ASSIGNMENT_BYPASS"
  | "DISCUSSION_CLOSED"
  | "EC261_REGULATION_NOT_APPLICABLE"
  | "TOTAL_COMPENSATION_REFUSAL"
  | "NOT_INVOLUNTARY";

export interface AdversaryRefusalReason {
  id: number;
  type: AdversaryRefusalReasonType;
  displayName: string;
  icon: LucideIcon;
}

/** Port of utils/config/constants/adversary-refusal-reasons.ts (Vue). */
export const ADVERSARY_REFUSAL_REASONS: AdversaryRefusalReason[] = [
  {
    id: 1,
    type: "ASSIGNMENT_REFUSAL",
    displayName: "Refus de reconnaitre la cession",
    icon: FileX2,
  },
  {
    id: 2,
    type: "NO_RESPONSE",
    displayName: "Aucune réponse – Silence de la compagnie",
    icon: MessageCircleOff,
  },
  {
    id: 3,
    type: "CX",
    displayName: "Circonstance extraordinaire",
    icon: CloudLightning,
  },
  {
    id: 4,
    type: "ADDITIONAL_FEES_REFUSAL",
    displayName: "Refus de payer les frais supplémentaires",
    icon: Banknote,
  },
  {
    id: 5,
    type: "ASK_FOR_ADDITIONAL_DOCS",
    displayName: "Réclamation de document supplémentaire",
    icon: FilePlus2,
  },
  {
    id: 6,
    type: "RESPONSABILITY_SHIFT_TO_OTHER_AIRLINE",
    displayName: "Renvoi vers une autre compagnie aérienne",
    icon: Plane,
  },
  {
    id: 7,
    type: "ASK_FOR_EXCESSIVE_DOCUMENTATION",
    displayName: "Abus de demande",
    icon: FileWarning,
  },
  {
    id: 8,
    type: "NOT_ELIGIBLE_REFUSAL",
    displayName: "Refus car non éligible au règlement (retard < 3h)",
    icon: XCircle,
  },
  {
    id: 9,
    type: "ASSIGNMENT_BYPASS",
    displayName: "Contournement de cession / Paiement au passager",
    icon: Speech,
  },
  {
    id: 10,
    type: "DISCUSSION_CLOSED",
    displayName: "Refus de donner suite",
    icon: MessageSquareX,
  },
  {
    id: 11,
    type: "EC261_REGULATION_NOT_APPLICABLE",
    displayName: "Invoque règlement pas applicable (Compétence)",
    icon: Scale,
  },
  {
    id: 12,
    type: "TOTAL_COMPENSATION_REFUSAL",
    displayName: "Refus de payer le totalité",
    icon: ReceiptText,
  },
  {
    id: 13,
    type: "NOT_INVOLUNTARY",
    displayName: "Changement horaire volontaire",
    icon: CalendarClock,
  },
];

export function getAdversaryRefusalReasonById(id: number): AdversaryRefusalReason | undefined {
  return ADVERSARY_REFUSAL_REASONS.find((reason) => reason.id === id);
}
